module.exports = __webpack_public_path__ + "static/media/ios-archive.ec93fa37.svg";